import { useEffect } from 'react';
import { usePopper } from 'react-popper';
import { useTheme } from "../../../hooks";
export var useTooltip = function (_a) {
    var shouldRecalculatePosition = _a.shouldRecalculatePosition, referenceElement = _a.referenceElement, popperElement = _a.popperElement, placement = _a.placement;
    var theme = useTheme();
    var _b = usePopper(referenceElement, popperElement, {
        placement: placement,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [parseInt(theme.space.md), parseInt(theme.space.md)]
                }
            }
        ]
    }), styles = _b.styles, attributes = _b.attributes, forceUpdate = _b.forceUpdate;
    useEffect(function () {
        if (forceUpdate && shouldRecalculatePosition) {
            forceUpdate();
        }
    }, [forceUpdate, shouldRecalculatePosition]);
    return {
        styles: styles,
        attributes: attributes
    };
};
//# sourceMappingURL=useTooltip.js.map